export default "__VITE_ASSET__Bz0LYA88__"